<div
  class="card"
  [style.border]="itemStyle().card.border"
  [style.boxShadow]="itemStyle().card.boxShadow"
  [style.background]="itemStyle().card.background"
  [style.borderRadius]="itemStyle().card.borderRadius"
>
  <img
    class="step-img"
    [src]="stepContent().picture.imageUrl"
    [alt]="
      stepContent().picture.alternativeText | replaceVars: maxSelectedChallenges
    "
  />

  <div class="card-body">
    @let indicatorImage = stepContent().indicatorImage;
    <p
      class="card-title"
      [style.color]="itemStyle().title.color"
      [style.fontFamily]="itemStyle().title.fontFamily"
    >
      @if (indicatorImage) {
        <img
          class="indicator-image"
          [src]="indicatorImage.imageUrl"
          [alt]="indicatorImage.alternativeText"
        />
      }
      {{ stepContent().title }}
    </p>
    <p
      class="card-text"
      [style.color]="itemStyle().description.color"
      [style.fontFamily]="itemStyle().description.fontFamily"
      [innerHTML]="
        stepContent().description | replaceVars: maxSelectedChallenges | safe
      "
    ></p>
  </div>
</div>
